import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D84076D2-8C7C-4CD7-98EA-05108B10FF1A
 * name skew-more
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skew-more.svg
 * tags
 * - Math 
 */
export const SkewMoreIcon = createSvgIcon(<><path d="M12.5,11L10.41,20H5.5L7.59,11H12.5M15,9H6L3,22H12L15,9M21,6L17,2V5H9V7H17V10L21,6Z" /></>, 'SkewMoreIcon');
export default SkewMoreIcon